<template>
  <b-modal v-if="network" id="join-network-modal" v-model="show" hide-footer hide-header no-close-on-esc no-close-on-backdrop size="lg">
    <div class="row mt-n2">
      <span class="text-end fs-3 pointer pe-0" @click="redirect ? $router.push('/') : $bvModal.hide('join-network-modal')"><i class="fa-solid fa-xmark"></i></span>
      <div class="profile-page">
        <div class="profile-header rounded-3">
          <div class="cover">
            <div class="rounded-3"></div>
            <div class="row rounded-3 rounded-top-0 bg-primary bg-opacity-50 h-25 p-sm-0" style="position: absolute; width: 100%; bottom: 0;">
              <!--Desktop-->
              <div class="d-none d-md-none d-lg-block">
                <div class="col-xl-3 col-lg-4 col-md-4">
                  <avatar
                  :size="100"
                  :username="network.short_name"
                  :src="network.logo_url"
                  class="profile-pic rounded-circle ms-4 bg-gradient-primary-dark"
                  style="margin-top: -3rem; font-size: 45px;"
                  >
                  </avatar>
                </div>
                <div class="col-xl-9 col-lg-8 col-md-8 mt-n5" style="margin-left: 10rem;">
                  <strong class="text-white display-8">{{ network.name }}</strong>
                </div>
              </div>
              <!--Mobile-->
              <div class="d-lg-none d-xl-none">
                <div class="col-xl-3 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                  <avatar
                  :size="55"
                  :username="network.short_name"
                  :src="network.logo_url"
                  class="profile-pic rounded-circle bg-gradient-primary-dark"
                  style="margin-top: -2rem; font-size: 20px;"
                  ></avatar>
                </div>
                <div class="col-xl-9 col-lg-8 col-md-8 col-sm-12 col-xs-12 pt-n6" style="margin-left: 4rem; margin-top: -1.1rem;">
                  <strong class="text-white">{{ network.short_name }}</strong>
                </div>
              </div>
            </div>
            <figure style="margin: 0;">
              <!--Desktop-->
              <div class="d-none d-md-none d-lg-block">
                <img
                  v-if="!network.cover_url"
                  src="@/assets/img/networks-home-default-banner.jpeg"
                  :alt="this.$t('Home.default-profile-cover')"
                  class="img-fluid rounded-3 bg-white"
                  style="height: 20rem;"
                />
                <img v-else :src="network.cover_url" :alt="this.$t('Home.profile-cover')" class="img-fluid rounded-3 bg-white" style="height: 20rem;" />
              </div>
              <!--Mobile-->
              <div class="d-lg-none d-xl-none">
                <img
                  v-if="!network.cover_url"
                  src="@/assets/img/networks-home-default-banner.jpeg"
                  :alt="this.$t('Home.default-profile-cover')"
                  class="img-fluid rounded-3 bg-white"
                />
                <img v-else :src="network.cover_url" :alt="this.$t('Home.profile-cover')" class="img-fluid rounded-3 bg-white" />
              </div>
            </figure>
          </div>
        </div>
      </div>
    </div>
    <!--Dynamic content-->
    <div v-if="instance == 'showIndustryMembershipExpiredModal'" class="text-center pt-3 px-6 mt-3">
      <h5 class="text-secondary mb-4">
        {{ $t('your-access-to-this-network-has-expired') }}
        <br>
        {{ $t('please-reach-out-to-the-business-development-team-for-renewal') }}
      </h5>
      <a id="contact_support" data-test="contact_support" data-umami-event="contact-support-email" href="mailto:bd@resonancehealth.org" class="btn btn-primary" style="padding: 8px 32px;">
        {{ $t('contact-support') }}
      </a>
    </div>
    <div v-if="instance == 'showPendingModerationModal'" class="text-center pt-3 px-6 mt-3">
      <h5 class="text-secondary mb-4">
        {{ $t('your-request-to-join-the-network-is-being-reviewed-by-the-network-admin-you-will-receive-an-email-when-there-is-an-update-about-your-membership-status-if-you-have-any-questions-please-contact-the-support-team', { network: network.short_name }) }}
      </h5>
      <button id="contact_support" data-test="contact_support" class="btn btn-primary" style="padding: 8px 32px;" @click="contactNow">{{ $t('contact-support') }}</button>
    </div>
    <div v-if="instance == 'showIndustryPendingModerationModal'" class="text-center pt-3 px-6 mt-3">
      <h5 class="text-secondary mb-4">
        {{ $t('your-access-to-this-network-is-under-review') }}
        <br>
        {{ $t('please-contact-the-business-development-team-with-any-questions') }}
      </h5>
      <a id="contact_support" data-test="contact_support" data-umami-event="contact-support-email" href="mailto:bd@resonancehealth.org" class="btn btn-primary" style="padding: 8px 32px;">
        {{ $t('contact-support') }}
      </a>
    </div>
    <div v-if="instance == 'showRejectedModerationModal'" class="text-center pt-3 px-6 mt-3">
      <h5 class="text-secondary mb-4">
        {{ $t('sorry-your-request-to-join-the-network-is-denied-at-this-time-if-you-have-any-questions-please-contact-the-support-team', { network: network.short_name }) }}
      </h5>
      <button id="contact_support" data-test="contact_support" class="btn btn-primary" style="padding: 8px 32px;" @click="contactNow">{{ $t('contact-support') }}</button>
    </div>
    <div v-if="instance == 'showIndustryRejectedModerationModal'" class="text-center pt-3 px-6 mt-3">
      <h5 class="text-secondary mb-4">
        {{ $t('your-request-to-join-this-network-has-been-rejected') }}
        <br>
        {{ $t('please-contact-the-business-development-team-with-any-questions') }}
      </h5>
      <a id="contact_support" data-test="contact_support" data-umami-event="contact-support-email" href="mailto:bd@resonancehealth.org" class="btn btn-primary" style="padding: 8px 32px;">
        {{ $t('contact-support') }}
      </a>
    </div>
    <div v-if="instance == 'showModerationModal'" class="text-center pt-3 px-6 mt-3">
      <h5 class="text-secondary mb-4">
        {{ $t('this-is-a-moderated-network-the-network-admin-will-review-your-request-for-membership') }}
      </h5>
      <button id="request_to_join" data-test="request_to_join" class="btn btn-primary" style="padding: 8px 32px;" @click="joinNetwork(network)">{{ $t('network.request-to-join') }}</button>
    </div>
    <div v-if="instance == 'showPublicJoinModal'" class="text-center pt-3 px-6 mt-3">
      <h5 class="text-secondary mb-4">
        {{ $t('become-a-member-of-this-network-for-access-to-resources-updates-and-more') }}
      </h5>
      <button id="join" data-test="join" class="btn btn-primary" style="padding: 8px 32px;" @click="joinNetwork(network)">{{ $t('network.join') }}</button>
    </div>
    <div v-if="instance == 'showPublicRestrictedModal'" class="text-center pt-3 px-6 mt-3">
      <h5 class="text-secondary mb-4">
        {{ $t('this-is-a-restricted-network-membership-is-by-invitation-only-however-the-content-is-open-to-public-view-if-you-have-any-questions-please-contact-the-support-team') }}
      </h5>
      <button id="contact_support" data-test="contact_support" class="btn btn-primary" style="padding: 8px 32px;" @click="contactNow">{{ $t('contact-support') }}</button>
    </div>
    <div v-if="instance == 'showPrivateModal'" class="text-center pt-3 px-6 mt-3">
      <h5 class="text-secondary mb-4">
        {{ $t('this-is-a-private-network-membership-is-by-invitation-only-if-you-have-any-questions-please-contact-the-support-team') }}
      </h5>
      <button id="contact_support" data-test="contact_support" class="btn btn-primary" style="padding: 8px 32px;" @click="contactNow">{{ $t('contact-support') }}</button>
    </div>
    <!--from media-->
    <div v-if="instance == 'showPendingModerationModalFromMedia'" class="text-center pt-3 px-6 mt-3">
      <h5 class="text-secondary mb-4">
        You need to be a member of the {{ network.short_name }} network to be able to see this content, but your request to join is still being reviewed.
        If you have any questions, please contact the support team.
      </h5>
      <button id="contact_support" data-test="contact_support" class="btn btn-primary" style="padding: 8px 32px;" @click="contactNow">{{ $t('contact-support') }}</button>
    </div>
    <div v-if="instance == 'showRejectedModerationModalFromMedia'" class="text-center pt-3 px-6 mt-3">
      <h5 class="text-secondary mb-4">
        You need to be a member of the {{ network.short_name }} network to be able to see this content, but your request to join has been denied at this time.
        If you have any questions, please contact the support team.
      </h5>
      <button id="contact_support" data-test="contact_support" class="btn btn-primary" style="padding: 8px 32px;" @click="contactNow">{{ $t('contact-support') }}</button>
    </div>
    <div v-if="instance == 'showModerationModalFromMedia'" class="text-center pt-3 px-6 mt-3">
      <h5 class="text-secondary mb-4">
        Please apply to join the {{ network.short_name }} network to be able to access resources, updates, and more.
        The network admin will review your request for membership.
      </h5>
      <button id="request_to_join_from_media" data-test="request_to_join_from_media" class="btn btn-primary" style="padding: 8px 32px;" @click="joinNetwork(network)">{{ $t('network.request-to-join') }}</button>
    </div>
    <div v-if="instance == 'showPublicJoinModalFromMedia'" class="text-center pt-3 px-6 mt-3">
      <h5 class="text-secondary mb-4">
        Please join the {{ network.short_name }} network to be able to access resources, updates, and more.
      </h5>
      <button id="join_from_media" data-test="join_from_media" class="btn btn-primary" style="padding: 8px 32px;" @click="joinNetwork(network)">{{ $t('network.join') }}</button>
    </div>
    <div v-if="instance == 'showPublicRestrictedModalFromMedia'" class="text-center pt-3 px-6 mt-3">
      <h5 class="text-secondary mb-4">
        {{ $t('this-is-a-restricted-network-membership-is-by-invitation-only-however-the-content-is-open-to-public-view-if-you-have-any-questions-please-contact-the-support-team') }}
      </h5>
      <button id="contact_support" data-test="contact_support" class="btn btn-primary" style="padding: 8px 32px;" @click="contactNow">{{ $t('contact-support') }}</button>
    </div>
    <div v-if="instance == 'showPrivateModalFromMedia'" class="text-center pt-3 px-6 mt-3">
      <h5 class="text-secondary mb-4">
        You're not authorized to see this content.
        {{ $t('this-is-a-private-network-membership-is-by-invitation-only-if-you-have-any-questions-please-contact-the-support-team') }}
      </h5>
      <button id="contact_support" data-test="contact_support" class="btn btn-primary" style="padding: 8px 32px;" @click="contactNow">{{ $t('contact-support') }}</button>
    </div>
    <!--logged out-->
    <div v-if="instance == 'showLoggedOutModal'" class="text-center pt-3 px-6 mt-3">
      <h5 class="text-secondary mb-4">
        {{ $t('please-sign-in-or-create-an-account-to-access-resources-updates-and-more-in-the-network', { network: network.short_name }) }} </h5>
      <button id="login" data-test="login" class="btn btn-primary" style="padding: 8px 32px;" @click="navigate(signin_url)">{{ $t('network.auth.login') }}</button>
      <br /><br />
      <span>
        {{ $t('new-to-resonance') }}
        <span class="text-primary fw-semibold" style="cursor: pointer;" @click="navigate(signup_url)">
          {{ $t('network.auth.signUp') }}
        </span>
      </span>
    </div>
  </b-modal>
</template>
<script>
//import Modal from '@/components/commons/Modals/Modal.vue';
import queryString from 'query-string';
import Avatar from 'vue-avatar';
import { mapState } from 'vuex';

export default {
  components: {
    Avatar,
    //Modal,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    instance: {
      type: String,
      default: null,
    },
    network: {
      type: Object,
      default: null,
    },
    redirect: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      //
    };
  },
  computed: {
    env() {
      return process.env.VUE_APP_ENV;
    },
    /**
     * Returns the combined version of the oauth login URL
     */
    signin_url() {
      let query = queryString.stringify({
        client_id: process.env.VUE_APP_OAUTH_SERVER_ID,
        redirect_uri: process.env.VUE_APP_OAUTH_SERVER_REDIRECT_URI,
        response_type: 'code',
      });
      return process.env.VUE_APP_OAUTH_SERVER_URI + '/oauth/authorize?' + query;
    },
    signup_url() {
      let query = queryString.stringify({
        client_id: process.env.VUE_APP_OAUTH_SERVER_ID,
        redirect_uri: process.env.VUE_APP_OAUTH_SERVER_REDIRECT_URI,
        response_type: 'code',
        register: 'true',
        email: this.registrationEmail,
      });

      return process.env.VUE_APP_OAUTH_SERVER_URI + '/oauth/authorize?' + query;
    },
    ...mapState({
      nextURL: state => state.auth.nextURL,
    }),
  },
  methods: {
    joinNetwork(network) {
      // Ask the user for confirmation first
      this.$bvModal.msgBoxConfirm(this.$t('network.confirmMembership')).then(value => {
        if (value) {
          this.$router.push('/join-network?network=' + network.slug);
        }
      });
    },
    navigate(url) {
      // for cross origin navigation
      window.location.href = url;
    },
    contactNow() {
      if (window.umami && typeof window.umami.track === 'function') {
        window.umami.track('open-support-modal');
      }
      this.$bus.emit('show-support-form');
    },
    loginAuth(nextURL) {
      if (nextURL) {
        this.$store.dispatch('setNextURL', nextURL);
      }
      this.navigate(this.signin_url);
    },
  },
};
</script>
<style scoped>
.profile-page .profile-header {
  box-shadow: 0 0 10px 0 rgba(183, 192, 206, 0.2);
  border: 1px solid #f2f4f9;
  width: 100%;
}
.profile-page .profile-header .cover {
  position: relative;
  border-radius: 0.25rem 0.25rem 0 0;
}
.profile-page .profile-header .cover figure img {
  border-radius: 0.25rem 0.25rem 0 0;
  width: 100%;
}
.profile-page .profile-header .cover .gray-shade {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: linear-gradient(rgba(0, 0, 0, 0.1), rgb(0, 0, 0) 450%);
}
.profile-page .profile-header .cover .cover-body {
  position: absolute;
  bottom: 10px;
  left: 20px;
  z-index: 2;
  width: 100%;
  padding: 0 20px;
}
.profile-page .profile-header .cover .cover-body .profile-pic {
  border-radius: 50%;
  width: 100px;
  font-size: 85px !important;
}
.profile-page .profile-header .cover .cover-body .profile-name {
  color: white;
  font-size: 20px;
  font-weight: 600;
  margin-left: 17px;
}
.profile-page .profile-header .header-links {
  padding: 15px;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: center;
  justify-content: center;
  background: #fff;
  border-radius: 0 0 0.25rem 0.25rem;
}
.profile-page .profile-header .header-links ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.profile-page .profile-header .header-links ul li a {
  color: #000;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
</style>